import React from "react";
import axios from "axios";

export const apiStates = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR"
}

export const useApi = (url) => {
  const [apiStore, setApiStore] = React.useState({
    state: apiStates.LOADING,
    error: null,
    content: null
  })

  const setPartData = (partialData) => setApiStore({ ...apiStore, ...partialData })

  React.useEffect(() => {
    setPartData({ state: apiStates.LOADING });
    axios(url)
      .then(({ data }) => {
        setPartData({
          state: apiStates.SUCCESS,
          content: {
            translations: data.Translations,
            locations: data.Offices.map(({
              GpsCoordinates,
              Name,
              Street,
              StreetNumber,
              FallbackAddress = '',
              Zipcode,
              PostalTown,
              ...rest
            }) => {
              const [lat, lng] = GpsCoordinates
                ? GpsCoordinates.split(',')
                : ['59.3463258', '18.0396855']; // Fallback to headquarter if null.
              return {
                name: Name,
                address: !!Street ? `${Street} ${StreetNumber}` : FallbackAddress,
                zip: Zipcode,
                town: PostalTown,
                lat: Number(lat),
                lng: Number(lng),
                ...rest
              }
            })
          }
        })
      })
      .catch((error) => {
        setPartData({ state: apiStates.ERROR, error: `Fetch failed: ${error.message}` })
      });
  }, []);

  return apiStore;
}
